<template>
    <div style="margin: 2rem">
        <div class="row" style="flex-wrap: wrap-reverse !important;">
            <div class=" col-sm-12 col-md-8" style="font-size: 16px ">
                <h1>{{ $t('why_support') }} </h1>
                <p>{{ $t('legacy_media') }} </p>
                <p>{{ $t('we_operate') }} </p>
                <p>{{ $t('we_dont_care') }} </p>
                <p>{{ $t('your_contribution') }} </p>
            </div>

            <div class=" col-sm-12 col-md-4">
                <img src="/assets/images/supportUs.png">
            </div>

        </div>

            <div class="support-popup-page">
                <div class="row">
                    <div class="support-popup-top">
                        <h3>{{ $t('support_us') }} </h3>
                        <p>{{ $t('please_select_how_you_want_to_make_a_donation') }}</p>
                    </div>

                </div>
                <div class="row">
                    <div class="credit-card col-md-12">
                        <div class="row">
                            <div class="col-md-3">
                                <p><img src="/assets/images/credit-card.svg" alt=""/> Credit Card</p>
                            </div>
                            <div class="col-md-4">
                                <footer style="padding-top: 0; background: unset; margin-top: 0">
                                    <div class="footer-Newsletter-input" v-if="$store.state.language.code !== 'tr'">
                                        <form :action="$store.state.hrefPrefix + '/support-us/pay'" method="post"
                                              ref="support" @submit.prevent="">
                                            <input type="hidden" name="_token" :value="csrf">
                                            <div class="Newsletter-input">
                                                <input type="number" :placeholder="$t('amount_usd')" name="amount"/>
                                                <button style="width: 100%" class="g-recaptcha"
                                                        data-sitekey="6Ld3Xv8mAAAAAJSdwXb6BysaOps8-vQJMk9W_ej5"
                                                        data-callback="submitSupportFromPage">
                                                    {{ $t('SUPPORT') }}
                                                </button>
                                            </div>
                                        </form>

                                    </div>
                                </footer>
                            </div>

                        </div>


                    </div>
<!--                    <hr>-->
<!--                    <div class="support-box col-md-3" style="margin-top: 10px">-->
<!--                        <div class="support-info">-->
<!--                            <i><img src="/assets/images/parteron-icon.svg" alt=""/></i>-->
<!--                            <p>{{ $t('patreon') }}</p>-->
<!--                        </div>-->
<!--                        <span>-->
<!--                        <a href="https://www.patreon.com/thecradlemedia" style="color: black" target="_blank">-->
<!--                        <div>{{ $t('go_to_website') }}  <i><img src="/assets/images/share-icon.svg" alt=""/></i>-->
<!--                            </div>-->
<!--                        </a>-->
<!--                    </span>-->
<!--                    </div>-->
<!--                    <hr>-->
<!--                    <div class="support-box col-md-3 " style="margin-top: 10px">-->
<!--                        <div class="support-info">-->
<!--                            <i><img src="/assets/images/usdt-icon.svg" alt=""/></i>-->
<!--                            <p>{{ $t('usdt') }} <span>{{ $t('network') }}</span> <code id="p2">{{-->
<!--                                    $t('tron_trc20')-->
<!--                                }} </code></p>-->
<!--                        </div>-->
<!--                        <span @click="copyTRONAddressToClipboard">-->
<!--                        <div>-->
<!--                      {{ $t('copy_address') }}  <i><img src="/assets/images/copy-icon.svg" alt=""/></i>-->
<!--                      </div>-->
<!--                    </span>-->
<!--                    </div>-->
<!--                    <hr>-->
<!--                    <div class="support-box col-md-3" style="margin-top: 10px">-->
<!--                        <div class="support-info">-->
<!--                            <i><img src="/assets/images/btc-icon.svg" alt=""/></i>-->
<!--                            <p>{{ $t('btc') }} <span>{{ $t('network') }}</span> <code id="p1">{{-->
<!--                                    $t('btc_segwit')-->
<!--                                }} </code></p>-->
<!--                        </div>-->
<!--                        <span @click="copyBTCAddressToClipboard"><div>{{ $t('copy_address') }} <i><img-->
<!--                            src="/assets/images/copy-icon.svg"-->
<!--                            alt=""/></i></div></span>-->
<!--                    </div>-->
                </div>

            </div>
        </div>


</template>

<style scoped>

</style>

<script>
import SupportPopup from "@/parts/home/TopBar/SupportPopup.vue";

export default {
    name: "SupportUsPage",
    components: {SupportPopup},
    data() {
        return {
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content')
        }
    },

    methods: {
        copyTRONAddressToClipboard() {
            const address = 'TEyZtrShUqFdmHYeiqYyvMc3DnYWKrcSkV';

            navigator.clipboard.writeText(address);

            alert('Address copied to clipboard!');
        },

        copyBTCAddressToClipboard() {
            const address = 'bc1qd864czk7zrrvuf5uvm0f6fecfn78mt6w8e0356';

            navigator.clipboard.writeText(address);

            alert('Address copied to clipboard!');
        },
        submitSupport(response) {
            console.log(response)
            const form = this.$refs.support;
            form.submit();
        }
    },
    mounted() {
        window.submitSupportFromPage = this.submitSupport;
    }
}
</script>
<style scoped>


.footer-Support {
    width: 143px;
    height: 42px;
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 700;
    margin: 3rem auto 0;
    background-color: var(--cdl-primary);
    padding: 0;
    color: var(--cdl-white);
    justify-content: center;
    cursor: pointer;
    border: 0;
}

.footer-Support:hover {
    background-color: var(--cdl-white);
    color: var(--cdl-primary);

}

.footer-Support:hover i {
    filter: none;
}

.footer-Support i {
    filter: brightness(0) invert(1);
}
</style>
